export const GENERATE_2FA = "GENERATE_2FA";
export const AUTHENTICATE_2FA = "AUTHENTICATE_2FA";

export const generate2Fa = (op) => {
    return {
        type: GENERATE_2FA,
        optype:op
    }
}

export const authenticate2Fa = (data,op) => {
    return {
        type: AUTHENTICATE_2FA,
        payload: data,
        optype:op
    };
}


